import React from "react";

export const CKYCUploadFileWithName = (props) => {
    
    return <>
        <div className="row">
            <div className="col-md-12">
                <p>Proof of {props.title} ({props.title === "Identity" ? "POI" : "POA"})</p>
            </div>
            <div className="col-md-4">
                <select className="packageForm" value={props.DocumentTypeID} onChange={(e) => props.setDocumentType(e.target.value)} required>
                    <option value="">Select Document</option>
                    {props.CKYCData.map(row => <option value={row.Name}>{row.Name}</option>)}
                </select>
            </div>
            <div className="col-md-4">
                <input type="text" placeholder="Document ID" value={props.DocumentIDValue} onChange={(e) => props.setDocumentID(e.target.value)} className="packageForm" required />
            </div>
            <div className="col-md-4">
                <div className="UploadDocuments" style={{ display: props.DocumentBase64 === "" ? "" : "none" }}>

                    <input type="file" accept="image/*" onChange={async (e) => props.setDocumentBase64(await toBase64(e.target.files[0]))} name="fileUpload" id={props.title === "Identity" ? "POI" : "POA"} hidden required />
                    <label htmlFor={props.title === "Identity" ? "POI" : "POA"} className="POS_File_Upload_Box">
                        <img src={require("./POS_IMG/upload.svg")} />
                        <p>Click to upload file</p>
                    </label>
                </div>
                <div style={{ display: props.DocumentBase64 === "" ? "none" : "" }} className="UIM_After02">
                    <button type="button" className="close" onClick={() => props.setDocumentBase64("")}>X</button>
                    <img src={props.DocumentBase64} title={props.title} />
                </div>

            </div>
        </div>
    </>
}
export const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});